<template>
  <section class="flex-content">
    <div class="flex-box">
      <div
        v-for="(item, index) in sidebarPremium"
        :key="index"
        class="flex-info">
        <span>{{ item.item }}</span>
        <span>{{ item.premium_str }}</span>
        <!--        <span>{{ item.premium | formatMoney(2, true) }}</span>-->
      </div>
      <slot></slot>
      <div
        class="flex-info total-amount">
        <span>Total</span>
        <span class="amount">{{amount | formatMoney(2, true) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinFormat from '@/mixins/format'

export default {
  name: 'PlanQuoteInfo',
  mixins: [MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    amount: {
      type: [Number,String],
      default: 0
    },
    isSpecial: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.formData
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    sidebarPremium() {
      if(!this.formData) {
        return []
      }
      let { sidebar_premium=[]} =this.formData
      if(sidebar_premium.length<=0)return  []
      let premium =sidebar_premium.filter(item => item.name != 'paid')
      if(this.isSpecial){
        premium = sidebar_premium.filter(item => item.name != 'code_disc_prm')
      }
      return  premium
    },
  },
  watch: {
    formData: {
      immediate: true,
      handler(val) {
        this.form = val
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-content {
  width: 280px;
  .flex-box {
    border-radius: 5px;
    border: 1px solid #E1E4E8;
    width: 280px;
    margin: 16px 0;

    .flex-info {
      display: flex;
      justify-content: space-between;
      padding: 23px 15px;
      border-bottom: 1px solid #E1E4E8;

      span:first-child {
        color: #586069;
        font-size: 14px;
        font-weight: 500;
        width: 50%;
      }

      span:last-child {
        color: #24292E;
        font-size: 14px;
      }
      .flex-column{
        p{
          font-size: 14px;
          font-weight: 500;
          height: 24px;
        }
        .item_title{
          color: #586069;
        }
        .name{
          color: #0366D6;
        }
        .flag_tag{
          span{
            color: #C24E00;
            padding: 0px 8px;
            background: #FFFFFF;
            border: 1px solid #F66A0A;
            border-radius: 100px;
            height: 22px;
            display: inline-block;
            width: auto;
          }
        }
      }
    }

    .total-amount {
      background: #f6f8fa;
      border-bottom: 0;
    }
    .transa-color{
      span{
        color: rgb(205,43,56)!important;
      }

    }

    .amount {
      color: #24292E;
      font-weight: bolder;
    }
  }
}
</style>